
// // src/components/QRCode.jsx 
// import React, { useEffect, useState } from 'react';
// import { QRCodeSVG } from 'qrcode.react';

// /**
//  * Enhanced QR Code component that generates network-specific payment QR codes
//  * Now includes Phantom/Solana support
//  */
// const QRCode = ({ 
//   walletAddress, 
//   amount, 
//   currency, 
//   network,
//   theme = 'light',
//   size = 200 
// }) => {
//   const [qrData, setQrData] = useState('');
//   const [qrError, setQrError] = useState(null);
//   const [isGenerating, setIsGenerating] = useState(true);
  
//   useEffect(() => {
//     generatePaymentQRData();
//   }, [walletAddress, amount, currency, network]);

//   const generatePaymentQRData = () => {
//     if (!walletAddress || walletAddress === 'No address configured') {
//       setQrError('No wallet address configured for this network');
//       setIsGenerating(false);
//       return;
//     }
    
//     try {
//       setIsGenerating(true);
//       let paymentData;
      
//       // Format QR code data based on network and currency
//       switch (network.toLowerCase()) {
//         case 'algorand':
//           paymentData = generateAlgorandQR(walletAddress, amount, currency);
//           break;
          
//         case 'tron':
//           paymentData = generateTronQR(walletAddress, amount, currency);
//           break;
          
//         case 'bsc':
//           paymentData = generateBSCQR(walletAddress, amount, currency);
//           break;
          
//         case 'solana':
//           paymentData = generateSolanaQR(walletAddress, amount, currency);
//           break;
          
//         case 'ethereum':
//         default:
//           paymentData = generateEthereumQR(walletAddress, amount, currency);
//           break;
//       }
      
//       setQrData(paymentData);
//       setQrError(null);
//       setIsGenerating(false);
      
//       // Debug logging to see what QR code is generated
//       console.log('=== QR CODE DEBUG ===');
//       console.log('Network:', network);
//       console.log('Currency:', currency);
//       console.log('Amount:', amount);
//       console.log('Wallet Address:', walletAddress);
//       console.log('Generated QR Data:', paymentData);
//       console.log('QR Data Length:', paymentData.length);
//       console.log('=== END QR DEBUG ===');
//     } catch (err) {
//       console.error('Error generating QR code:', err);
//       setQrError('Error generating payment QR code');
//       setIsGenerating(false);
//     }
//   };

//   // Generate Ethereum QR code
//   const generateEthereumQR = (address, amount, currency) => {
//     const amountFloat = parseFloat(amount);
    
//     if (currency === 'ETH') {
//       // Native ETH transfer
//       const amountWei = (amountFloat * 1e18).toString();
//       return `ethereum:${address}@1?value=${amountWei}`;
//     } else {
//       // ERC20 token transfer
//       const tokenConfig = getTokenConfigForCurrency(currency, 'ethereum');
//       if (tokenConfig && tokenConfig.contractAddress) {
//         const decimals = tokenConfig.decimals || 18;
//         const amountInSmallestUnit = (amountFloat * Math.pow(10, decimals)).toString();
//         return `ethereum:${tokenConfig.contractAddress}/transfer?address=${address}&uint256=${amountInSmallestUnit}`;
//       } else {
//         // Fallback to just the address
//         return address;
//       }
//     }
//   };

//   // Generate BSC QR code
//   const generateBSCQR = (address, amount, currency) => {
//     const amountFloat = parseFloat(amount);
    
//     if (currency === 'BNB') {
//       // Native BNB transfer
//       const amountWei = (amountFloat * 1e18).toString();
//       return `ethereum:${address}@56?value=${amountWei}`;
//     } else {
//       // BEP20 token transfer
//       const tokenConfig = getTokenConfigForCurrency(currency, 'bsc');
//       if (tokenConfig && tokenConfig.contractAddress) {
//         const decimals = tokenConfig.decimals || 18;
//         const amountInSmallestUnit = (amountFloat * Math.pow(10, decimals)).toString();
//         return `ethereum:${tokenConfig.contractAddress}/transfer?address=${address}&uint256=${amountInSmallestUnit}@56`;
//       } else {
//         return address;
//       }
//     }
//   };

//   // Generate TRON QR code
//   const generateTronQR = (address, amount, currency) => {
//     const amountFloat = parseFloat(amount);
    
//     if (currency === 'TRX') {
//       // Native TRX transfer
//       const amountSun = (amountFloat * 1e6).toString();
//       return `tronlink://transfer?to=${address}&amount=${amountSun}`;
//     } else {
//       // TRC20 token transfer
//       const tokenConfig = getTokenConfigForCurrency(currency, 'tron');
//       if (tokenConfig && tokenConfig.contractAddress) {
//         const decimals = tokenConfig.decimals || 6;
//         const amountInSmallestUnit = (amountFloat * Math.pow(10, decimals)).toString();
//         return `tronlink://token-transfer?contract=${tokenConfig.contractAddress}&to=${address}&amount=${amountInSmallestUnit}`;
//       } else {
//         // Just return the address for manual entry
//         return address;
//       }
//     }
//   };

//   // Generate Algorand QR code compatible with Pera Wallet
//   const generateAlgorandQR = (address, amount, currency) => {
//     try {
//       const amountFloat = parseFloat(amount);
      
//       if (currency === 'ALGO') {
//         // Native ALGO transfer
//         const microAlgos = Math.floor(amountFloat * 1000000);
//         return `algorand://${address}?amount=${microAlgos}&note=Payment`;
//       } else {
//         // ASA transfers (USDC, USDT)
//         const tokenConfig = getTokenConfigForCurrency(currency, 'algorand');
//         if (tokenConfig && tokenConfig.assetId) {
//           const assetAmount = Math.floor(amountFloat * Math.pow(10, tokenConfig.decimals));
//           return `algorand://${address}?amount=${assetAmount}&asset=${tokenConfig.assetId}&note=Payment`;
//         } else {
//           // Just return the address for manual entry
//           console.warn(`Token config not found for ${currency} on Algorand`);
//           return address;
//         }
//       }
//     } catch (error) {
//       console.error('Error generating Algorand QR:', error);
//       return address; // Fallback to address only
//     }
//   };

//   // NEW: Generate Solana QR code compatible with Phantom and other Solana wallets
//   const generateSolanaQR = (address, amount, currency) => {
//     try {
//       const amountFloat = parseFloat(amount);
      
//       console.log('Generating Solana QR code:', {
//         address,
//         amount,
//         currency,
//         amountFloat
//       });
      
//       if (currency === 'SOL') {
//         // Native SOL transfer - use the amount as-is since Phantom handles the conversion to lamports
//         // Solana Pay format doesn't require lamports conversion in QR code
//         return `solana:${address}?amount=${amountFloat}&label=Payment`;
//       } else {
//         // SPL token transfer
//         const tokenConfig = getTokenConfigForCurrency(currency, 'solana');
//         if (tokenConfig && tokenConfig.contractAddress) {
//           // For SPL tokens in QR codes, we also use the human-readable amount
//           // The wallet app will handle the decimal conversion
//           return `solana:${address}?amount=${amountFloat}&spl-token=${tokenConfig.contractAddress}&label=Payment`;
//         } else {
//           // Just return the address for manual entry
//           console.warn(`Token config not found for ${currency} on Solana`);
//           return address;
//         }
//       }
//     } catch (error) {
//       console.error('Error generating Solana QR:', error);
//       return address; // Fallback to address only
//     }
//   };
  
//   // Get token configuration for currency and network
//   const getTokenConfigForCurrency = (currency, network) => {
//     const tokenConfigs = {
//       ethereum: {
//         'USDT': { contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7', decimals: 6 },
//         'USDC': { contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', decimals: 6 },
//         'DAI': { contractAddress: '0x6B175474E89094C44Da98b954EedeAC495271d0F', decimals: 18 },
//         'PYUSD': { contractAddress: '0x6c3ea9036406852006290770BEdFcAbA0e23A0e8', decimals: 6 },
//         'USDP': { contractAddress: '0x8E870D67F660D95d5be530380D0eC0bd388289E1', decimals: 18 },
//         'FRAX': { contractAddress: '0x853d955aCEf822Db058eb8505911ED77F175b99e', decimals: 18 }
//       },
//       bsc: {
//         'USDT': { contractAddress: '0x55d398326f99059fF775485246999027B3197955', decimals: 18 },
//         'USDC': { contractAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', decimals: 18 },
//         'BUSD': { contractAddress: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56', decimals: 18 },
//         'FRAX': { contractAddress: '0x90C97F71E18723b0Cf0dfa30ee176Ab653E89F40', decimals: 18 }
//       },
//       tron: {
//         'USDT': { contractAddress: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t', decimals: 6 },
//         'USDC': { contractAddress: 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8', decimals: 6 },
//         'USDJ': { contractAddress: 'TMwFHYXLJaRUPeW6421aqXL4ZEzPRFGkGT', decimals: 18 }
//       },
//       algorand: {
//         'USDC': { assetId: 31566704, decimals: 6 },
//         'USDT': { assetId: 312769, decimals: 6 },
//         'ALGO': { decimals: 6, isNative: true }
//       },
//       solana: {
//         'USDC': { contractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v', decimals: 6 },
//         'USDT': { contractAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB', decimals: 6 },
//         'SOL': { decimals: 9, isNative: true }
//       }
//     };
    
//     return tokenConfigs[network]?.[currency.toUpperCase()];
//   };

//   // Get network display name
//   const getNetworkDisplayName = (network) => {
//     const names = {
//       ethereum: 'Ethereum',
//       bsc: 'BSC',
//       tron: 'TRON',
//       algorand: 'Algorand',
//       solana: 'Solana'
//     };
//     return names[network.toLowerCase()] || network;
//   };

//   // Get wallet app suggestions based on network
//   const getWalletSuggestions = (network) => {
//     const suggestions = {
//       ethereum: ['MetaMask', 'Trust Wallet', 'Coinbase Wallet'],
//       bsc: ['MetaMask', 'Trust Wallet', 'SafePal'],
//       tron: ['TronLink', 'Trust Wallet'],
//       algorand: ['Pera Wallet', 'MyAlgo Wallet'],
//       solana: ['Phantom', 'Solflare', 'Sollet']
//     };
//     return suggestions[network.toLowerCase()] || ['MetaMask', 'Trust Wallet'];
//   };

//   // Copy to clipboard function
//   const copyToClipboard = async (text) => {
//     try {
//       await navigator.clipboard.writeText(text);
//       // You can add a toast notification here if you have one
// //     } catch (err) {
//       console.error('Failed to copy to clipboard:', err);
//     }
//   };

//   // Format wallet address for display
//   const formatWalletAddress = (address) => {
//     if (!address || address.length <= 16) return address;
//     return `${address.slice(0, 6)}...${address.slice(-4)}`;
//   };

//   return (
//     <div className="flex flex-col items-center">
//       {qrError ? (
//         <div className="p-4 rounded-lg bg-red-100 mb-3 text-red-700 text-center">
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//           </svg>
//           <p className="font-medium">{qrError}</p>
//         </div>
//       ) : (
//         <div className="p-4 rounded-lg bg-white mb-3 shadow-sm border">
//           {isGenerating ? (
//             <div className={`flex items-center justify-center`} style={{ width: size, height: size }}>
//               <div className="text-center">
//                 <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto mb-2"></div>
//                 <div className="text-sm text-gray-600">Generating QR Code...</div>
//               </div>
//             </div>
//           ) : qrData ? (
//             <QRCodeSVG
//               value={qrData}
//               size={size}
//               bgColor={theme === 'dark' ? '#374151' : '#FFFFFF'}
//               fgColor={theme === 'dark' ? '#FFFFFF' : '#000000'}
//               level="H"
//               includeMargin={true}
//             />
//           ) : null}
//         </div>
//       )}
      
//       <div className="text-center text-sm text-gray-700 mb-4">
//         <p className='font-semibold text-gray-800 flex items-center justify-center'>
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M12 12h-4.01M12 12V8.01" />
//           </svg>
//           Scan to Pay with {currency}
//         </p>
//         <p className="text-xs text-gray-500 mt-1">
//           Scan with your {getNetworkDisplayName(network)} wallet app
//         </p>
//       </div>
      
//       {/* Payment Amount Display */}
//       <div className="w-full mb-4 p-3 bg-gray-50 rounded-lg">
//         <div className="flex justify-between items-center">
//           <span className="text-sm font-medium text-gray-700">Amount to Pay:</span>
//           <span className="text-lg font-bold text-[#7042D2]">{amount} {currency}</span>
//         </div>
//         <div className="flex justify-between items-center mt-1">
//           <span className="text-xs text-gray-500">Network:</span>
//           <span className="text-xs font-medium text-gray-700">{getNetworkDisplayName(network)}</span>
//         </div>
//         <div className="flex justify-between items-center mt-1">
//           <span className="text-xs text-gray-500">Recipient:</span>
//           <span className="text-xs font-mono text-gray-700">{formatWalletAddress(walletAddress)}</span>
//         </div>
//       </div>


//       {/* Copy Payment URI Button (for advanced users) */}
//       {qrData && qrData !== walletAddress && (
//         <div className="w-full mb-4">
//           <button
//             onClick={() => copyToClipboard(qrData)}
//             className="w-full p-2 bg-blue-100 hover:bg-blue-200 text-blue-800 rounded-lg transition-colors flex items-center justify-center gap-2 text-sm"
//           >
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.103m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
//             </svg>
//             Copy Payment URI
//           </button>
//         </div>
//       )}
      
//       {/* Instructions */}
//       <div className="w-full">
//         <div className="p-3 rounded bg-blue-50 border border-blue-200">
//           <h4 className="text-sm font-medium mb-2 text-blue-800 flex items-center">
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             Payment Instructions
//           </h4>
//           <ol className="text-xs space-y-1 text-blue-700">
//             <li>1. Open your crypto wallet app ({getWalletSuggestions(network).join(', ')})</li>
//             <li>2. Scan the QR code above or copy the wallet address</li>
//             <li>3. Send exactly <strong>{amount} {currency}</strong> on {getNetworkDisplayName(network)} network</li>
//             <li>4. Click "I have sent the payment" button below after sending</li>
//           </ol>
          
//           <div className="mt-3 p-2 bg-yellow-50 border border-yellow-200 rounded">
//             <p className="text-xs text-yellow-800">
//               <strong>Important:</strong> Make sure you're sending on the correct network ({getNetworkDisplayName(network)}) 
//               and using the exact amount shown above.
//             </p>
//           </div>

         
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QRCode;











// src/components/QRCode.jsx 
import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * Enhanced QR Code component that generates network-specific payment QR codes
 * Now includes Trust Wallet support for all networks
 */
const QRCode = ({ 
  walletAddress, 
  amount, 
  currency, 
  network,
  theme = 'light',
  size = 200 
}) => {
  const [qrData, setQrData] = useState('');
  const [qrError, setQrError] = useState(null);
  const [isGenerating, setIsGenerating] = useState(true);
  
  useEffect(() => {
    generatePaymentQRData();
  }, [walletAddress, amount, currency, network]);

  const generatePaymentQRData = () => {
    if (!walletAddress || walletAddress === 'No address configured') {
      setQrError('No wallet address configured for this network');
      setIsGenerating(false);
      return;
    }
    
    try {
      setIsGenerating(true);
      let paymentData;
      
      // Format QR code data based on network and currency
      switch (network.toLowerCase()) {
        case 'algorand':
          paymentData = generateAlgorandQR(walletAddress, amount, currency);
          break;
          
        case 'tron':
          paymentData = generateTronQR(walletAddress, amount, currency);
          break;
          
        case 'bsc':
          paymentData = generateBSCQR(walletAddress, amount, currency);
          break;
          
        case 'solana':
          paymentData = generateSolanaQR(walletAddress, amount, currency);
          break;
          
        case 'ethereum':
        default:
          paymentData = generateEthereumQR(walletAddress, amount, currency);
          break;
      }
      
      setQrData(paymentData);
      setQrError(null);
      setIsGenerating(false);
      
    } catch (err) {
      console.error('Error generating QR code:', err);
      setQrError('Error generating payment QR code');
      setIsGenerating(false);
    }
  };

  // Generate Ethereum QR code
  const generateEthereumQR = (address, amount, currency) => {
    const amountFloat = parseFloat(amount);
    
    if (currency === 'ETH') {
      // Native ETH transfer
      const amountWei = (amountFloat * 1e18).toString();
      return `ethereum:${address}@1?value=${amountWei}`;
    } else {
      // ERC20 token transfer
      const tokenConfig = getTokenConfigForCurrency(currency, 'ethereum');
      if (tokenConfig && tokenConfig.contractAddress) {
        const decimals = tokenConfig.decimals || 18;
        const amountInSmallestUnit = (amountFloat * Math.pow(10, decimals)).toString();
        return `ethereum:${tokenConfig.contractAddress}/transfer?address=${address}&uint256=${amountInSmallestUnit}`;
      } else {
        // Fallback to just the address
        return address;
      }
    }
  };

  // Generate BSC QR code
  const generateBSCQR = (address, amount, currency) => {
    const amountFloat = parseFloat(amount);
    
    if (currency === 'BNB') {
      // Native BNB transfer
      const amountWei = (amountFloat * 1e18).toString();
      return `ethereum:${address}@56?value=${amountWei}`;
    } else {
      // BEP20 token transfer
      const tokenConfig = getTokenConfigForCurrency(currency, 'bsc');
      if (tokenConfig && tokenConfig.contractAddress) {
        const decimals = tokenConfig.decimals || 18;
        const amountInSmallestUnit = (amountFloat * Math.pow(10, decimals)).toString();
        return `ethereum:${tokenConfig.contractAddress}/transfer?address=${address}&uint256=${amountInSmallestUnit}@56`;
      } else {
        return address;
      }
    }
  };

  // Generate TRON QR code - Enhanced for Trust Wallet
  const generateTronQR = (address, amount, currency) => {
    const amountFloat = parseFloat(amount);
    
    if (currency === 'TRX') {
      // Native TRX transfer - Support both TronLink and Trust Wallet formats
      const amountSun = (amountFloat * 1e6).toString();
      
      // TronLink format (primary)
      const tronLinkFormat = `tronlink://transfer?to=${address}&amount=${amountSun}`;
      
      // Trust Wallet also supports TronLink format, but we can add additional compatibility
      // Trust Wallet format as fallback (they support the same URI scheme)
      const trustWalletFormat = `tron:${address}?amount=${amountSun}`;
      
      // Return TronLink format as it's more widely supported and Trust Wallet supports it
      return tronLinkFormat;
    } else {
      // TRC20 token transfer
      const tokenConfig = getTokenConfigForCurrency(currency, 'tron');
      if (tokenConfig && tokenConfig.contractAddress) {
        const decimals = tokenConfig.decimals || 6;
        const amountInSmallestUnit = (amountFloat * Math.pow(10, decimals)).toString();
        
        // TronLink format for tokens
        return `tronlink://token-transfer?contract=${tokenConfig.contractAddress}&to=${address}&amount=${amountInSmallestUnit}`;
      } else {
        // Just return the address for manual entry
        return address;
      }
    }
  };

  // Generate Algorand QR code compatible with Pera Wallet
  const generateAlgorandQR = (address, amount, currency) => {
    try {
      const amountFloat = parseFloat(amount);
      
      if (currency === 'ALGO') {
        // Native ALGO transfer
        const microAlgos = Math.floor(amountFloat * 1000000);
        return `algorand://${address}?amount=${microAlgos}&note=Payment`;
      } else {
        // ASA transfers (USDC, USDT)
        const tokenConfig = getTokenConfigForCurrency(currency, 'algorand');
        if (tokenConfig && tokenConfig.assetId) {
          const assetAmount = Math.floor(amountFloat * Math.pow(10, tokenConfig.decimals));
          return `algorand://${address}?amount=${assetAmount}&asset=${tokenConfig.assetId}&note=Payment`;
        } else {
          // Just return the address for manual entry
          console.warn(`Token config not found for ${currency} on Algorand`);
          return address;
        }
      }
    } catch (error) {
      console.error('Error generating Algorand QR:', error);
      return address; // Fallback to address only
    }
  };

  // Enhanced Solana QR code compatible with Phantom and Trust Wallet
  const generateSolanaQR = (address, amount, currency) => {
    try {
      const amountFloat = parseFloat(amount);
      
      
      if (currency === 'SOL') {
        // Native SOL transfer - Compatible with both Phantom and Trust Wallet
        // Both wallets support the Solana Pay standard format
        return `solana:${address}?amount=${amountFloat}&label=Payment`;
      } else {
        // SPL token transfer
        const tokenConfig = getTokenConfigForCurrency(currency, 'solana');
        if (tokenConfig && tokenConfig.contractAddress) {
          // For SPL tokens, both Phantom and Trust Wallet support this format
          return `solana:${address}?amount=${amountFloat}&spl-token=${tokenConfig.contractAddress}&label=Payment`;
        } else {
          // Just return the address for manual entry
          console.warn(`Token config not found for ${currency} on Solana`);
          return address;
        }
      }
    } catch (error) {
      console.error('Error generating Solana QR:', error);
      return address; // Fallback to address only
    }
  };
  
  // Get token configuration for currency and network
  const getTokenConfigForCurrency = (currency, network) => {
    const tokenConfigs = {
      ethereum: {
        'USDT': { contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7', decimals: 6 },
        'USDC': { contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', decimals: 6 },
        'DAI': { contractAddress: '0x6B175474E89094C44Da98b954EedeAC495271d0F', decimals: 18 },
        'PYUSD': { contractAddress: '0x6c3ea9036406852006290770BEdFcAbA0e23A0e8', decimals: 6 },
        'USDP': { contractAddress: '0x8E870D67F660D95d5be530380D0eC0bd388289E1', decimals: 18 },
        'FRAX': { contractAddress: '0x853d955aCEf822Db058eb8505911ED77F175b99e', decimals: 18 }
      },
      bsc: {
        'USDT': { contractAddress: '0x55d398326f99059fF775485246999027B3197955', decimals: 18 },
        'USDC': { contractAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', decimals: 18 },
        'BUSD': { contractAddress: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56', decimals: 18 },
        'FRAX': { contractAddress: '0x90C97F71E18723b0Cf0dfa30ee176Ab653E89F40', decimals: 18 }
      },
      tron: {
        'USDT': { contractAddress: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t', decimals: 6 },
        'USDC': { contractAddress: 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8', decimals: 6 },
        'USDJ': { contractAddress: 'TMwFHYXLJaRUPeW6421aqXL4ZEzPRFGkGT', decimals: 18 }
      },
      algorand: {
        'USDC': { assetId: 31566704, decimals: 6 },
        'USDT': { assetId: 312769, decimals: 6 },
        'ALGO': { decimals: 6, isNative: true }
      },
      solana: {
        'USDC': { contractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v', decimals: 6 },
        'USDT': { contractAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB', decimals: 6 },
        'SOL': { decimals: 9, isNative: true }
      }
    };
    
    return tokenConfigs[network]?.[currency.toUpperCase()];
  };

  // Get network display name
  const getNetworkDisplayName = (network) => {
    const names = {
      ethereum: 'Ethereum',
      bsc: 'BSC',
      tron: 'TRON',
      algorand: 'Algorand',
      solana: 'Solana'
    };
    return names[network.toLowerCase()] || network;
  };

  // Enhanced wallet app suggestions including Trust Wallet for all supported networks
  const getWalletSuggestions = (network) => {
    const suggestions = {
      ethereum: ['MetaMask', 'Trust Wallet', 'Coinbase Wallet'],
      bsc: ['MetaMask', 'Trust Wallet', 'SafePal'],
      tron: ['TronLink', 'Trust Wallet'], // Trust Wallet now supports TRON
      algorand: ['Pera Wallet', 'MyAlgo Wallet'],
      solana: ['Phantom', 'Trust Wallet', 'Solflare'] // Trust Wallet now supports Solana
    };
    return suggestions[network.toLowerCase()] || ['MetaMask', 'Trust Wallet'];
  };

  // Copy to clipboard function
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      // You can add a toast notification here if you have one
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
    }
  };

  // Format wallet address for display
  const formatWalletAddress = (address) => {
    if (!address || address.length <= 16) return address;
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  return (
    <div className="flex flex-col items-center">
      {qrError ? (
        <div className="p-4 rounded-lg bg-red-100 mb-3 text-red-700 text-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <p className="font-medium">{qrError}</p>
        </div>
      ) : (
        <div className="p-4 rounded-lg bg-white mb-3 shadow-sm border">
          {isGenerating ? (
            <div className={`flex items-center justify-center`} style={{ width: size, height: size }}>
              <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto mb-2"></div>
                <div className="text-sm text-gray-600">Generating QR Code...</div>
              </div>
            </div>
          ) : qrData ? (
            <QRCodeSVG
              value={qrData}
              size={size}
              bgColor={theme === 'dark' ? '#374151' : '#FFFFFF'}
              fgColor={theme === 'dark' ? '#FFFFFF' : '#000000'}
              level="H"
              includeMargin={true}
            />
          ) : null}
        </div>
      )}
      
      <div className="text-center text-sm text-gray-700 mb-4">
        <p className='font-semibold text-gray-800 flex items-center justify-center'>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M12 12h-4.01M12 12V8.01" />
          </svg>
          Scan to Pay with {currency}
        </p>
        <p className="text-xs text-gray-500 mt-1">
          Scan with your {getNetworkDisplayName(network)} wallet app
        </p>
      </div>
      
      {/* Payment Amount Display */}
      <div className="w-full mb-4 p-3 bg-gray-50 rounded-lg">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-gray-700">Amount to Pay:</span>
          <span className="text-lg font-bold text-[#7042D2]">{amount} {currency}</span>
        </div>
        <div className="flex justify-between items-center mt-1">
          <span className="text-xs text-gray-500">Network:</span>
          <span className="text-xs font-medium text-gray-700">{getNetworkDisplayName(network)}</span>
        </div>
        <div className="flex justify-between items-center mt-1">
          <span className="text-xs text-gray-500">Recipient:</span>
          <span className="text-xs font-mono text-gray-700">{formatWalletAddress(walletAddress)}</span>
        </div>
      </div>


      {/* Copy Payment URI Button (for advanced users) */}
      {qrData && qrData !== walletAddress && (
        <div className="w-full mb-4">
          <button
            onClick={() => copyToClipboard(qrData)}
            className="w-full p-2 bg-blue-100 hover:bg-blue-200 text-blue-800 rounded-lg transition-colors flex items-center justify-center gap-2 text-sm"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.103m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
            </svg>
            Copy Payment URI
          </button>
        </div>
      )}
      
      {/* Instructions - Enhanced for Trust Wallet */}
      <div className="w-full">
        <div className="p-3 rounded bg-blue-50 border border-blue-200">
          <h4 className="text-sm font-medium mb-2 text-blue-800 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Payment Instructions
          </h4>
          <ol className="text-xs space-y-1 text-blue-700">
            <li>1. Open your crypto wallet app ({getWalletSuggestions(network).join(', ')})</li>
            <li>2. Scan the QR code above or copy the wallet address</li>
            <li>3. Send exactly <strong>{amount} {currency}</strong> on {getNetworkDisplayName(network)} network</li>
            <li>4. Click "I have sent the payment" button below after sending</li>
          </ol>
          
          <div className="mt-3 p-2 bg-yellow-50 border border-yellow-200 rounded">
            <p className="text-xs text-yellow-800">
              <strong>Important:</strong> Make sure you're sending on the correct network ({getNetworkDisplayName(network)}) 
              and using the exact amount shown above.
            </p>
          </div>

          {/* Enhanced Trust Wallet specific note */}
          {getWalletSuggestions(network).includes('Trust Wallet') && (
            <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded">
              <p className="text-xs text-green-800">
                <strong>Trust Wallet users:</strong> Trust Wallet supports {getNetworkDisplayName(network)} payments. 
                Make sure you have the correct network selected in your Trust Wallet app.
              </p>
            </div>
          )}
         
        </div>
      </div>
    </div>
  );
};

export default QRCode;







